"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRules = void 0;
const _FEDERAL_1 = require("./_FEDERAL");
/**
 * Behavior inherits; the spec never does. A state overrides only the slots
 * where its law departs from federal — inherited slots return FEDERAL-stamped
 * answers, the honest reading of "this state falls back to federal law here"
 * — but it must author its own complete expectations table, including rows
 * claiming those inherited federal answers. Were `expectations` inherited
 * too, a half-written state would pass the sweep with federal rows
 * masquerading as reviewed state claims. `derivations` is abstract for the
 * same reason: inheriting the federal table would let a state's rows expand
 * through federal routing, with the export printing federal determinations
 * under the state's heading.
 *
 * A state without generator tiers of its own takes the default `never` and
 * an empty `stateStatusDomain`, so its state status always narrows to null.
 */
class StateRules extends _FEDERAL_1.FederalRules {
    isValidStateGeneratorStatus(status) {
        return this.stateStatusDomain.some((domain) => domain === status);
    }
    // A stored stateGeneratorStatus that this state's law does not define is
    // data corruption — treat same as "could not be determined"
    narrowToJurisdiction(ctx) {
        if (this.isValidStateGeneratorStatus(ctx.stateGeneratorStatus)) {
            return { ...ctx, stateGeneratorStatus: ctx.stateGeneratorStatus };
        }
        return { ...ctx, stateGeneratorStatus: null };
    }
    narrowAccumulationThresholdContext(ctx) {
        if (this.isValidStateGeneratorStatus(ctx.stateGeneratorStatus)) {
            return {
                generatorStatus: ctx.generatorStatus,
                stateGeneratorStatus: ctx.stateGeneratorStatus,
            };
        }
        return { generatorStatus: ctx.generatorStatus, stateGeneratorStatus: null };
    }
}
exports.StateRules = StateRules;
//# sourceMappingURL=_stateRules.js.map